import React, { useState } from "react";
import image1 from "../../../assets/frontendassets/png images (2)/png images/portrait-happy-businessman-dressed-suit 1.png";
import { Col, Row, message } from "antd";
import { newsletter } from "../../../utils/API";

const NewsletterSubscription = () => {
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleSubscribe = async (event : any) => {
    event.preventDefault();
    const email = event.target.email.value;

    if (!email) {
      message.warning("Please enter a valid email address.");
      return;
    }

    setIsSubmitting(true);
    try {
      const response = await newsletter({ email });
      if (response.status === 200) {
        event.target.reset(); // Clear the input field
        message.success("Subscribed successfully!");
      }
    } catch (error) {
      message.error("Subscription failed. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="flex items-center justify-center bg-[#FFF8EC] lg:py-6 md:py-6 2xl:py-12 px-6 sm:px-12">
      <Row align="middle">
        <Col xs={0} sm={2} md={2} lg={2} xl={2} xxl={2} className="bg-[#FFE8C2] h-[300px]"></Col>
        <Col xs={24} sm={6} md={8} lg={7} xl={6} xxl={6}>
          <div className="bg-[#F9B138] rounded-lg flex items-center justify-center px-6 py-10 h-80">
            <img
              src={image1}
              alt="Person Pointing"
              className="w-80 sm:h-62 h-[300px] z-10 lg:h-[360px] absolute bottom-0 left-5"
            />
          </div>
        </Col>
        <Col xs={24} sm={18} md={14} lg={15} xl={16} xxl={16}>
          <div className="bg-[#FFE8C2] w-full pt-6 pb-12 lg:pt-12 px-6 sm:px-12">
            <h2 className="text-[30px] sm:text-sm lg:text-4xl font-bold text-black mb-4 text-center sm:text-left">
              SUBSCRIBE TO NEWSLETTER
            </h2>
            <p className="text-base sm:text-sm lg:text-xl text-[#6A6767] mb-6 leading-relaxed text-center sm:text-left">
              Enter your email to subscribe and stay connected with tailored updates and insights for your business. Don’t miss out—subscribe now!
            </p>
            <form
              className="flex flex-col sm:flex-row justify-center lg:justify-start items-center sm:space-x-4 space-y-4 sm:space-y-0"
              onSubmit={handleSubscribe}
            >
              <input
                type="email"
                name="email"
                placeholder="Enter your email address..."
                className="w-full sm:w-[400px] md:w-[600px] lg:w-[600px] h-[56px] px-4 py-3 border bg-transparent border-black rounded-[5px] focus:outline-none focus:ring-2 focus:ring-[#f8cc6d]"
                disabled={isSubmitting}
              />
              <button
                type="submit"
                className="w-full sm:w-auto bg-[#F9B138] text-black lg:w-[250px] px-6 py-3 font-medium rounded-[5px] hover:bg-[#F9B138]"
                disabled={isSubmitting}
              >
                {isSubmitting ? "Subscribing..." : "Subscribe"}
              </button>
            </form>
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default NewsletterSubscription;
